import yaml, { YAMLException } from 'js-yaml'
import YAML from 'yaml'

import Monaco, { OnChange } from './components/Monaco'
import useDatasource from './hooks/useDatasource'
import { Datasource } from './interfaces'
import dump from './utilities/dumpYaml'

export function Export() {
  const [datasource, setDatasource] = useDatasource(true)

  const handleChange: OnChange = (value = '') => {
    try {
      const datasource = yaml.load(value) as Datasource
      // Prevents us from being routed back to the home page when removing or cutting the data from the export screen.
      if (!datasource) return
      setDatasource(datasource)
    } catch (error) {
      if (error instanceof YAMLException) return
      throw error
    }
  }

  const ast = YAML.parseDocument(dump(datasource))
  YAML.visit(ast, (_, node) => {
    if (YAML.isPair(node) && YAML.isScalar(node.key) && YAML.isScalar(node.value) && node.key.source === 'perform') {
      node.value.type = 'BLOCK_LITERAL'
      node.value.comment = ' js'
    }
  })
  const value = YAML.stringify(ast, { lineWidth: 0 })

  return <Monaco language="yaml" defaultValue={value} onChange={handleChange} />
}
